module.exports = __webpack_public_path__ + "static/media/open_down.9273922c.png";